module.exports = __webpack_public_path__ + "static/media/Twilio.bf7ef30f.svg";